/** @format */

import template from './gb-add-team-scoring-widget.html';

export const GbAddTeamScoringWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddTeamScoringWidgetComponent {
        constructor($gbTeamScoringProjectorWidget, $ccColors, $ccToast, $translate) {
            'ngInject';

            this.$gbTeamScoringProjectorWidget = $gbTeamScoringProjectorWidget;
            this.$ccColors = $ccColors;
            this.$ccToast = $ccToast;
            this.$translate = $translate;
        }

        addWidget() {
            if (this.gbPresenter.getTeamScoringWidgets().length > 0) {
                this.$ccToast.error(this.$translate.instant('ONLY_ONE_TEAM_SCORING_WIDGET_ALLOWED'));
                return;
            }
            let primaryBgColor = this.gbApp.getAuction().primary_color;
            let accentBgColor = this.gbApp.getAuction().accent_color;

            let widget = new this.$gbTeamScoringProjectorWidget({
                x: 25,
                y: 30,
                z: 1,
                x_unit: '%',
                y_unit: '%',
                width: 50,
                width_unit: '%',
                height: 65,
                height_unit: '%',
                opacity: 1,
                table_primary_color: primaryBgColor,
                table_accent_color: accentBgColor,
                font_size: 15,
                rows: 5,
                slide_interval: 10,
            });

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
